<script setup lang="ts">
/**
 * @description UI-kit typography component — plain text
 * @category UI / Typography
 * @figma https://www.figma.com/design/CFyOwQUjj7uVRQTc03muvG/CS-UI-kit?node-id=216-126902
 */
// types
import type { AppTextProps } from '../types/interfaces'
// hooks
import { useAppText } from '../composables/use-app-text.hook'

defineOptions({ name: 'AppText' })

const props = withDefaults(defineProps<AppTextProps>(), {
  name: 'body2',
  align: 'inherit',
  textDecoration: 'none',
  block: false,
  truncate: false,
})

const emit = defineEmits<{
  click: []
}>()

const {
  resolvedTag,
  classList,
  handleClick,
} = useAppText({
  props,
  onClick: () => emit('click'),
})
</script>

<template>
  <component
    :is="resolvedTag"
    :class="classList"
    @click="handleClick"
  >
    <slot />
  </component>
</template>

<style scoped lang="scss" src="../styles/_app-text.scss" />
